import styled from '@emotion/styled';
import { noop } from '@hotjar/webapp/lib/function';
import { Button, tokens, Stack, Text, Icon, Modal } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { TARGETING_VALUE_LABELS } from '@hotjar/heatmaps';
import type { UnpinConfirmationModalProps } from './PinnerTypes';

const ButtonRow = styled(Stack)`
  justify-content: flex-end;
`;

const FadedText = styled(Text)`
  color: ${tokens.color.text_light};
`;

export const UnpinConfirmationModal = ({
  name,
  pattern,
  isOpen,
  matchOperation,
  onClose = noop,
  onConfirm = noop,
}: UnpinConfirmationModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentLabel={t('heatmaps:remove-saved-heatmap-modal.content-label')}
    >
      <Modal.Header title={i18next.t('heatmaps:remove-saved-heatmap-modal.title', { name })} />
      <Modal.Body>
        <Stack direction="column" data-testid="pinner-unpin-content">
          <Text textType="body1">{t('heatmaps:remove-saved-heatmap-modal.description')}</Text>
          <Text textType="body2">
            <Icon size="m" icon="hyperlink" />{' '}
            <FadedText>
              {t(TARGETING_VALUE_LABELS[matchOperation])}: {pattern}
            </FadedText>
          </Text>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonRow spacing="x1">
          <Button kind="ghost" onClick={onClose}>
            {t('heatmaps:remove-saved-heatmap-modal.cancel')}
          </Button>
          <Button kind="danger" onClick={onConfirm}>
            {t('heatmaps:remove-saved-heatmap-modal.remove')}
          </Button>
        </ButtonRow>
      </Modal.Footer>
    </Modal>
  );
};
